import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckoutForm from './CheckoutForm';
import { fundRaiserPageAction } from '../../store/actions';

export function DonateFundraiser() {
    let dispatch = useDispatch();
    let pageId = window.location.pathname.split("/");
    pageId = pageId[pageId.length - 1]
    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details)

    useEffect(() => {
        dispatch(fundRaiserPageAction.getFundRaiserPage(pageId, 'checkout_page'));
    }, [])
    return <CheckoutForm pageDetails={pageDetails} />
}